<template>
    <TitleSection cssClass="account-settings-title">
        <h1>{{ $t('views.account_subscriptions.title') }}</h1>
        <p>{{ $t('views.account_subscriptions.description') }}</p>
    </TitleSection>
</template>

<script>
    import TitleSection from '@/components/account/settings/Title';
    
    export default {
        name: 'AccountSubscriptionsTitle',
        components: {
            TitleSection
        }
    }
</script>